/**
 * Modern Media Modal / Mediathek for VvvebJs & Conversion Cloud
 */
function ucFirst(str) {
  if (!str) return str;
  return str[0].toUpperCase() + str.slice(1);
}

var generateElements =
  window.generateElements ||
  function (html) {
    const template = document.createElement("template");
    template.innerHTML = html.trim();
    return template.content.children;
  };

if (typeof mediaScanUrl === "undefined") {
  var mediaPath = "https://media.cs-erfolg.de/";
  var mediaScanUrl = "/media/scan";
  var uploadUrl = "/media/upload";
  var deleteUrl = "/media/delete";
  var renameUrl = "/media/rename";
}

class MediaModal {
  constructor(modal = true) {
    this.isInit = false;
    this.isModal = modal;
    this.activeFilter = "all"; // "all", "image", "document"

    this.modalHtml = `
    <div class="modal fade modal-full media-modal-wrapper" id="MediaModal" tabindex="-1" role="dialog" aria-labelledby="MediaModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
        <div class="modal-content shadow-lg border-0 rounded-4 overflow-hidden">
          <div class="modal-header bg-white border-bottom px-4 py-3 align-items-center">
            <div class="d-flex align-items-center">
              <div class="media-header-icon bg-primary bg-opacity-10 text-primary rounded-3 p-2 me-3 d-flex align-items-center justify-content-center">
                <i class="la la-photo-video la-lg"></i>
              </div>
              <div>
                <h5 class="modal-title fw-bold mb-0 text-dark" id="MediaModalLabel">Mediathek</h5>
                <small class="text-muted">Verwalte deine Bilder, Grafiken und Dokumente</small>
              </div>
            </div>
            <button type="button" class="btn-close shadow-none" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div class="modal-body p-0 bg-light">
            <div class="filemanager d-flex flex-column h-100">
              
              <!-- Toolbar -->
              <div class="media-toolbar bg-white px-4 py-3 border-bottom d-flex flex-wrap align-items-center justify-content-between gap-3 sticky-top z-3">
                <div class="d-flex align-items-center gap-2 flex-grow-1" style="max-width: 450px;">
                  <div class="search-input-wrapper position-relative w-100">
                    <i class="la la-search search-icon position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
                    <input type="search" id="media-search-input" class="form-control ps-5 pe-4 rounded-pill border-light bg-light shadow-none" placeholder="Datei suchen..." />
                    <button class="btn btn-link btn-sm text-muted search-clear position-absolute top-50 end-0 translate-middle-y me-2 d-none" type="button">
                      <i class="la la-times-circle"></i>
                    </button>
                  </div>
                </div>

                <div class="d-flex align-items-center gap-2">
                  <div class="btn-group media-filter-pills p-1 bg-light rounded-pill border border-light" role="group">
                    <button type="button" class="btn btn-sm rounded-pill px-3 active" data-filter="all">Alle</button>
                    <button type="button" class="btn btn-sm rounded-pill px-3" data-filter="image">Bilder</button>
                    <button type="button" class="btn btn-sm rounded-pill px-3" data-filter="document">Dokumente</button>
                  </div>

                  <button class="btn btn-primary rounded-pill px-4 btn-upload-toggle d-flex align-items-center gap-2 shadow-sm" 
                     data-bs-toggle="collapse" 
                     data-bs-target="#uploadCollapse" 
                     aria-expanded="false">
                     <i class="la la-cloud-upload-alt la-lg"></i>
                     <span>Datei hochladen</span>
                  </button>
                </div>
              </div>

              <!-- Upload Dropzone (Collapsible) -->
              <div class="top-panel px-4 pt-3">
                <div class="upload-collapse collapse mb-3" id="uploadCollapse">
                  <div class="upload-dropzone p-4 border border-2 border-dashed border-primary border-opacity-50 rounded-4 text-center bg-white position-relative shadow-sm">
                    <button id="upload-close" type="button" class="btn-close position-absolute top-0 end-0 m-3 shadow-none z-3" aria-label="Close"></button>
                    <input type="file" multiple class="dropzone-file-input position-absolute top-0 start-0 w-100 h-100 opacity-0 cursor-pointer z-2">
                    <div class="dropzone-content py-3 position-relative z-1 pointer-events-none">
                      <div class="dropzone-icon text-primary mb-3">
                        <i class="la la-cloud-upload-alt" style="font-size: 3.5rem;"></i>
                      </div>
                      <h5 class="fw-bold text-dark mb-1">Dateien hierher ziehen oder auswählen</h5>
                      <p class="text-muted small mb-3">Unterstützt JPG, PNG, GIF, SVG, WebP, PDF & mehr</p>
                      <span class="btn btn-outline-primary rounded-pill px-4 btn-sm fw-medium">
                        Computer durchsuchen
                      </span>
                    </div>
                    <div class="status position-relative z-3"></div>
                  </div>
                </div>
              </div>

              <!-- Media Content Container -->
              <div class="display-panel px-4 pb-4 flex-grow-1 overflow-auto">
                <div class="breadcrumbs text-muted mb-3 fs-7" style="display: none;"></div>
                
                <ul class="data media-grid list-unstyled mb-0" id="media-files"></ul>

                <div class="nothingfound py-5 text-center my-4" style="display: none;">
                  <div class="nofiles-icon bg-primary bg-opacity-10 text-primary rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style="width: 80px; height: 80px;">
                    <i class="la la-folder-open" style="font-size: 2.5rem;"></i>
                  </div>
                  <h6 class="fw-bold text-dark mb-1">Keine Dateien gefunden</h6>
                  <p class="text-muted small mb-3">Keine passenden Medien in dieser Kategorie vorhanden.</p>
                  <button class="btn btn-outline-primary btn-sm rounded-pill px-4" data-bs-toggle="collapse" data-bs-target="#uploadCollapse">
                    <i class="la la-cloud-upload-alt me-1"></i> Erste Datei hochladen
                  </button>
                </div>
              </div>

            </div>
          </div>

          <div class="modal-footer bg-white border-top px-4 py-3 d-flex align-items-center justify-content-between">
            <div class="media-selected-info text-muted small fw-medium">
              <span id="media-selected-text">Keine Auswahl</span>
            </div>
            <div class="d-flex align-items-center gap-2">
              <button type="button" class="btn btn-light rounded-pill px-4" data-bs-dismiss="modal">
                Abbrechen
              </button>
              <button type="button" class="btn btn-primary rounded-pill px-4 save-btn disabled shadow-sm" disabled>
                <i class="la la-check me-1"></i>
                <span>Auswahl übernehmen</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>`;

    this.response = [];
    this.currentPath = "";
    this.breadcrumbsUrls = [];
    this.filemanager = null;
    this.breadcrumbs = null;
    this.fileList = null;
    this.mediaPath = mediaPath;
    this.type = "single";
    this.container = document.getElementById("MediaModal");
  }

  getResponse(response) {
    return this.response;
  }

  setResponse(response) {
    this.response = response;
    this.currentPath = "";
    this.breadcrumbsUrls = [];
  }

  addModalHtml() {
    if (this.isModal) {
      let existingModal = document.getElementById("MediaModal");
      if (existingModal) existingModal.remove();
      document.body.append(generateElements(this.modalHtml)[0]);
    }
    this.container = document.getElementById("MediaModal");
    this.container.querySelector(".save-btn").addEventListener("click", () => this.save());
  }

  showUploadLoading() {
    let statusEl = this.container.querySelector(".upload-collapse .status");
    if (statusEl) {
      statusEl.innerHTML = `
        <div class="d-flex align-items-center justify-content-center py-4">
          <div class="spinner-border text-primary me-3" role="status"></div>
          <span class="fw-medium text-dark">Datei wird hochgeladen...</span>
        </div>`;
    }
  }

  hideUploadLoading() {
    let statusEl = this.container.querySelector(".upload-collapse .status");
    if (statusEl) statusEl.innerHTML = "";
  }

  save() {
    let checked = this.container.querySelector(".files input:checked");
    if (!checked) return;

    let file = checked.value ?? false;
    let src = file;

    if (!file) return;

    if (file.indexOf("//") === -1) {
      src = this.mediaPath + file;
    }

    if (this.targetThumb) {
      let thumbEl = document.querySelector(this.targetThumb);
      if (thumbEl) thumbEl.setAttribute("src", src);
    }

    if (this.callback) {
      this.callback(src);
    }

    if (this.targetInput) {
      let input = document.querySelector(this.targetInput);
      if (input) {
        input.value = src;
        input.dispatchEvent(new Event("input", { bubbles: true }));
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }

    let modal = bootstrap.Modal.getOrCreateInstance(this.container);
    if (this.isModal) modal.hide();
  }

  init() {
    if (!this.isInit) {
      if (this.isModal) this.addModalHtml();
      let self = this;

      this.initGallery();
      this.isInit = true;

      let fileInput = this.container.querySelector(".filemanager input[type=file]");
      if (fileInput) {
        fileInput.addEventListener("change", (e) => self.onUpload(e));
      }

      // Drag & Drop Highlight effect
      let dropzone = this.container.querySelector(".upload-dropzone");
      if (dropzone) {
        ["dragenter", "dragover"].forEach((eventName) => {
          dropzone.addEventListener(eventName, (e) => {
            e.preventDefault();
            dropzone.classList.add("bg-primary", "bg-opacity-20");
          });
        });
        ["dragleave", "drop"].forEach((eventName) => {
          dropzone.addEventListener(eventName, (e) => {
            e.preventDefault();
            dropzone.classList.remove("bg-primary", "bg-opacity-20");
          });
        });
      }

      // Event delegation for actions
      this.container.querySelector(".filemanager").addEventListener("click", function (e) {
        let btnDelete = e.target.closest(".btn-delete");
        if (btnDelete) {
          self.deleteFile(btnDelete);
          return;
        }
        let btnRename = e.target.closest(".btn-rename");
        if (btnRename) {
          self.renameFile(btnRename);
          return;
        }
        let btnClose = e.target.closest("#upload-close");
        if (btnClose) {
          bootstrap.Collapse.getOrCreateInstance(
            self.container.querySelector("#uploadCollapse")
          ).hide();
          return;
        }
      });

      // Filter tabs listener
      let filterPills = this.container.querySelectorAll(".media-filter-pills button");
      filterPills.forEach((pill) => {
        pill.addEventListener("click", (e) => {
          filterPills.forEach((p) => p.classList.remove("active", "bg-primary", "text-white"));
          pill.classList.add("active");
          self.activeFilter = pill.dataset.filter || "all";
          self.applyFilterAndSearch();
        });
      });

      const event = new CustomEvent("mediaModal:init", {
        detail: {
          type: this.type,
          targetInput: this.targetInput,
          targetThumb: this.targetThumb,
          callback: this.callback,
        },
      });
      window.dispatchEvent(event);
    }
  }

  open(element, callback) {
    if (element instanceof Element) {
      this.targetInput = element.dataset.targetInput;
      this.targetThumb = element.dataset.targetThumb;
      if (element.dataset.type) {
        this.type = element.dataset.type;
      }
    } else if (element) {
      this.targetInput = element.targetInput;
      this.targetThumb = element.targetThumb;
      if (element.type) {
        this.type = element.type;
      }
    }

    this.callback = callback;
    
    // Reset Search and Filters
    if (this.container) {
      let searchInput = this.container.querySelector("#media-search-input");
      let clearBtn = this.container.querySelector(".search-clear");
      if (searchInput) searchInput.value = "";
      if (clearBtn) clearBtn.classList.add("d-none");
      
      this.activeFilter = "all";
      let filterBtns = this.container.querySelectorAll(".media-filter-pills .btn");
      filterBtns.forEach(btn => btn.classList.remove("active"));
      let allBtn = this.container.querySelector(".media-filter-pills .btn[data-filter='all']");
      if (allBtn) allBtn.classList.add("active");
      
      // Uncheck any previously selected files
      let checked = this.container.querySelectorAll(".files input:checked");
      checked.forEach(el => el.checked = false);
      if (typeof this.updateSelectedInfo === "function") {
        this.updateSelectedInfo();
      }
      
      // Apply clean state
      if (typeof this.applyFilterAndSearch === "function") {
        this.applyFilterAndSearch();
      }
    }
    
    this.init();

    let modal = bootstrap.Modal.getOrCreateInstance(this.container);
    if (this.isModal) modal.show();
  }

  initGallery() {
    this.filemanager = this.container.querySelector(".filemanager");
    this.breadcrumbs = this.container.querySelector(".breadcrumbs");
    this.fileList = this.filemanager.querySelector(".data");
    let _this = this;

    if (!this.response.length) {
      fetch(mediaScanUrl)
        .then((response) => {
          if (!response.ok) throw new Error(response);
          return response.json();
        })
        .then((data) => {
          _this.response = data;
          _this.currentPath = "";
          _this.breadcrumbsUrls = [];

          if (_this.breadcrumbs) _this.breadcrumbs.style.display = "none";
          _this.applyFilterAndSearch();
        })
        .catch((error) => {
          console.error("Error loading media:", error);
          if (typeof displayToast === "function") {
            displayToast("bg-danger", "Fehler", "Medien konnten nicht geladen werden!");
          }
        });
    } else {
      this.applyFilterAndSearch();
    }

    // Modern Search Input Logic
    let searchInput = this.container.querySelector("#media-search-input");
    let clearBtn = this.container.querySelector(".search-clear");

    if (searchInput) {
      searchInput.addEventListener("input", function () {
        let val = this.value.trim();
        if (clearBtn) {
          if (val.length) clearBtn.classList.remove("d-none");
          else clearBtn.classList.add("d-none");
        }
        _this.applyFilterAndSearch();
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener("click", function () {
        if (searchInput) {
          searchInput.value = "";
          clearBtn.classList.add("d-none");
          _this.applyFilterAndSearch();
        }
      });
    }
  }

  applyFilterAndSearch() {
    let searchVal = (this.container.querySelector("#media-search-input")?.value || "").trim().toLowerCase();
    let items = this.searchByPath(this.currentPath || "") || this.response;

    let scannedFiles = [];
    let scannedFolders = [];

    let processItem = (d) => {
      if (d.type === "folder") {
        if (!searchVal || d.name.toLowerCase().includes(searchVal)) {
          scannedFolders.push(d);
        }
      } else if (d.type === "file") {
        let nameLower = d.name.toLowerCase();
        let matchesSearch = !searchVal || nameLower.includes(searchVal);
        let ext = nameLower.split(".").pop();
        let isImage = ["jpg", "jpeg", "png", "gif", "svg", "webp"].includes(ext);

        let matchesFilter = true;
        if (this.activeFilter === "image") matchesFilter = isImage;
        if (this.activeFilter === "document") matchesFilter = !isImage;

        if (matchesSearch && matchesFilter) {
          scannedFiles.push(d);
        }
      }
    };

    if (Array.isArray(items)) {
      items.forEach(processItem);
    } else if (typeof items === "object") {
      (items.files || []).forEach(processItem);
      (items.folders || []).forEach(processItem);
    }

    this.render({ folders: scannedFolders, files: scannedFiles });
  }

  searchByPath(dir) {
    if (!dir) return this.response;
    let path = dir.split("/");
    let demo = this.response;

    for (let i = 0; i < path.length; i++) {
      if (!path[i]) continue;
      for (let j = 0; j < demo.length; j++) {
        if (demo[j].name === path[i]) {
          demo = demo[j].items;
          break;
        }
      }
    }
    return demo;
  }

  onUpload(event) {
    let self = this;
    let fileInput = event ? event.target : null;
    let file = fileInput && fileInput.files ? fileInput.files[0] : null;

    if (file) {
      self.showUploadLoading();
      let reader = new FileReader();
      reader.onload = imageIsLoaded;
      reader.readAsDataURL(file);
    }

    function imageIsLoaded(e) {
      let formData = new FormData();
      formData.append("file", file);
      formData.append("mediaPath", self.mediaPath + self.currentPath);
      formData.append("onlyFilename", true);

      const csrfHeader = document.querySelector('meta[name="_csrf_header"]')?.content;
      const csrfToken = document.querySelector('meta[name="_csrf"]')?.content;
      const headers = {};
      if (csrfHeader && csrfToken) headers[csrfHeader] = csrfToken;

      fetch(uploadUrl, { method: "POST", headers: headers, body: formData })
        .then((response) => {
          if (!response.ok) {
            return Promise.resolve(response.text()).then((responseInText) => {
              return Promise.reject([response, responseInText]);
            });
          }
          return response.json();
        })
        .then((data) => {
          let fileElement = self.addFile(
            {
              name: data.name,
              type: data.type,
              path: data.path,
              size: 1,
            },
            true
          );

          if (fileElement) {
            fileElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }

          self.hideUploadLoading();
          let collapse = bootstrap.Collapse.getInstance(document.querySelector("#uploadCollapse"));
          if (collapse) collapse.hide();
        })
        .catch((error) => {
          let responseInText = error;
          if (Array.isArray(error)) responseInText = error[1];
          self.hideUploadLoading();
          if (typeof displayToast === "function") {
            displayToast("bg-danger", "Fehler", "Upload fehlgeschlagen!");
          }
        });
    }
  }

  deleteFile(el) {
    let parent = el.closest("li");
    let input = parent.querySelector('input[type="hidden"]');
    if (!input) return;

    let file = input.value;
    let filenameOnly = file.split("/").pop();

    if (confirm(`Möchtest du "${filenameOnly}" wirklich löschen?`)) {
      const csrfHeader = document.querySelector('meta[name="_csrf_header"]')?.content;
      const csrfToken = document.querySelector('meta[name="_csrf"]')?.content;
      const headers = {};
      if (csrfHeader && csrfToken) headers[csrfHeader] = csrfToken;

      fetch(deleteUrl, { method: "POST", headers: headers, body: new URLSearchParams({ file }) })
        .then((response) => {
          if (!response.ok) throw new Error("Delete failed");
          return response.json();
        })
        .then((data) => {
          if (typeof displayToast === "function") {
            displayToast("bg-success", "Gelöscht", "Datei wurde erfolgreich gelöscht.");
          }
          parent.remove();
          this.updateSelectedInfo();
        })
        .catch((error) => {
          if (typeof displayToast === "function") {
            displayToast("bg-danger", "Fehler", "Datei konnte nicht gelöscht werden.");
          }
        });
    }
  }

  renameFile(el) {
    let parent = el.closest("li");
    let input = parent.querySelector('input[type="hidden"]');
    if (!input) return;

    let file = input.value;
    let filenameOnly = file.split("/").pop();
    let newfile = prompt("Neuer Dateiname:", filenameOnly);

    if (newfile && newfile.trim() !== "" && newfile !== filenameOnly) {
      const csrfHeader = document.querySelector('meta[name="_csrf_header"]')?.content;
      const csrfToken = document.querySelector('meta[name="_csrf"]')?.content;
      const headers = {};
      if (csrfHeader && csrfToken) headers[csrfHeader] = csrfToken;

      fetch(renameUrl, {
        method: "POST",
        headers: headers,
        body: new URLSearchParams({ file, newfile: newfile.trim() }),
      })
        .then((response) => {
          if (!response.ok) throw new Error("Rename failed");
          return response.text();
        })
        .then((data) => {
          if (typeof displayToast === "function") {
            displayToast("bg-success", "Erfolg", "Datei wurde umbenannt.");
          }
          let nameEl = parent.querySelector(".media-file-name");
          if (nameEl) nameEl.textContent = newfile.trim();
        })
        .catch((error) => {
          if (typeof displayToast === "function") {
            displayToast("bg-danger", "Fehler", "Umbenennen fehlgeschlagen.");
          }
        });
    }
  }

  updateSelectedInfo() {
    let checked = this.container.querySelector(".files input:checked");
    let saveBtn = this.container.querySelector(".save-btn");
    let infoText = this.container.querySelector("#media-selected-text");

    if (checked) {
      let fileVal = checked.value;
      let filename = fileVal.split("/").pop();
      if (infoText) infoText.textContent = `Ausgewählt: ${filename}`;
      if (saveBtn) {
        saveBtn.disabled = false;
        saveBtn.classList.remove("disabled");
      }
    } else {
      if (infoText) infoText.textContent = "Keine Auswahl";
      if (saveBtn) {
        saveBtn.disabled = true;
        saveBtn.classList.add("disabled");
      }
    }
  }

  addFile(f, selected) {
    let _this = this;
    let isImage = false;

    let fileSize = _this.bytesToSize(f.size);
    let name = _this.escapeHTML(f.name);
    let fileParts = name.split(".");
    let fileType = fileParts[fileParts.length - 1].toLowerCase();
    let previewHtml = "";

    if (["jpg", "jpeg", "png", "gif", "svg", "webp"].includes(fileType)) {
      previewHtml = `<img class="media-thumb-img w-100 h-100 object-fit-cover rounded-3" loading="lazy" src="${_this.mediaPath}${f.path}" alt="${name}">`;
      isImage = true;
    } else {
      previewHtml = `
        <div class="media-file-icon-placeholder w-100 h-100 bg-white d-flex flex-column align-items-center justify-content-center rounded-3">
          <i class="la la-file-alt text-primary" style="font-size: 2.8rem;"></i>
          <span class="badge bg-secondary text-uppercase mt-2 fs-8">${fileType}</span>
        </div>`;
    }

    let itemHtml = `
      <li class="files media-card-item position-relative">
        <label class="media-card-label d-block rounded-3 p-2 bg-white border border-light shadow-sm h-100 transition-all cursor-pointer">
          <input type="hidden" value="${_this.mediaPath}${f.path}" name="filename[]">
          <input type="${_this.type === "single" ? "radio" : "checkbox"}" 
                 class="media-card-checkbox form-check-input position-absolute top-0 end-0 m-3 z-2" 
                 value="${f.path}" 
                 name="file[]" 
                 ${selected ? "checked" : ""}>
          
          <div class="media-card-thumb rounded-3 bg-light overflow-hidden position-relative mb-2" style="height: 130px;">
            ${previewHtml}
            <span class="media-ext-badge badge bg-dark bg-opacity-75 position-absolute bottom-0 start-0 m-2 text-uppercase fs-8">${fileType}</span>
          </div>

          <div class="media-card-body">
            <div class="media-file-name text-dark fw-medium text-truncate small mb-1" title="${name}">${name}</div>
            <div class="d-flex align-items-center justify-content-between">
              <span class="media-file-size text-muted fs-8">${fileSize}</span>
              <div class="media-card-actions opacity-75">
                <button type="button" title="Umbenennen" class="btn btn-link btn-sm p-0 text-muted btn-rename me-2"><i class="la la-edit"></i></button>
                <button type="button" title="Löschen" class="btn btn-link btn-sm p-0 text-danger btn-delete"><i class="la la-trash"></i></button>
              </div>
            </div>
          </div>
        </label>
      </li>`;

    let file = generateElements(itemHtml)[0];

    // Card Selection & Double Click Handlers
    let inputCheck = file.querySelector("input[type='radio'], input[type='checkbox']");
    let label = file.querySelector(".media-card-label");

    if (inputCheck && label) {
      inputCheck.addEventListener("change", () => {
        _this.container.querySelectorAll(".media-card-label").forEach((lbl) => lbl.classList.remove("border-primary", "shadow", "bg-primary-subtle"));
        if (inputCheck.checked) {
          label.classList.add("border-primary", "shadow");
        }
        _this.updateSelectedInfo();
      });

      // Double-click to insert file directly!
      file.addEventListener("dblclick", (e) => {
        e.preventDefault();
        inputCheck.checked = true;
        label.classList.add("border-primary", "shadow");
        _this.updateSelectedInfo();
        _this.save();
      });
    }

    _this.fileList.append(file);

    let nothingFound = _this.filemanager.querySelector(".nothingfound");
    if (nothingFound) nothingFound.style.display = "none";

    if (selected) {
      _this.updateSelectedInfo();
    }

    return file;
  }

  render(data) {
    let scannedFolders = [];
    let scannedFiles = [];

    if (Array.isArray(data)) {
      data.forEach((d) => {
        if (d.type === "folder") scannedFolders.push(d);
        else if (d.type === "file") scannedFiles.push(d);
      });
    } else if (typeof data === "object") {
      scannedFolders = data.folders || [];
      scannedFiles = data.files || [];
    }

    this.fileList.replaceChildren();

    let nothingFound = this.filemanager.querySelector(".nothingfound");
    if (!scannedFolders.length && !scannedFiles.length) {
      if (nothingFound) nothingFound.style.display = "block";
    } else {
      if (nothingFound) nothingFound.style.display = "none";
    }

    let _this = this;

    if (scannedFolders.length) {
      scannedFolders.forEach(function (f) {
        let itemsLength = f.items ? f.items.length : 0;
        let name = _this.escapeHTML(f.name);

        let folderHtml = `
          <li class="folders media-card-item media-folder-item position-relative">
            <a href="${f.path}" title="${f.path}" class="media-card-label d-flex align-items-center rounded-3 p-3 bg-white border border-light text-decoration-none shadow-sm h-100 transition-all">
              <div class="media-folder-icon bg-warning bg-opacity-10 text-warning rounded-3 p-2 me-3 d-flex align-items-center justify-content-center">
                <i class="la la-folder la-2x"></i>
              </div>
              <div class="media-card-body flex-grow-1 overflow-hidden">
                <div class="media-file-name text-dark fw-bold text-truncate small">${name}</div>
                <span class="media-file-size text-muted fs-8">${itemsLength} Elemente</span>
              </div>
            </a>
          </li>`;

        let folder = generateElements(folderHtml)[0];
        _this.fileList.append(folder);
      });
    }

    if (scannedFiles.length) {
      scannedFiles.forEach(function (f) {
        _this.addFile(f);
      });
    }

    this.updateSelectedInfo();
  }

  escapeHTML(text) {
    if (!text) return "";
    return text.replace(/\&/g, "&amp;").replace(/\</g, "&lt;").replace(/\>/g, "&gt;");
  }

  bytesToSize(bytes) {
    let sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    if (!bytes || bytes == 0) return "0 Bytes";
    let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
  }
}

window.MediaModal = MediaModal;
